import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Header,
  Textarea,
  Container,
  SpaceBetween,
  Box,
  Grid,
  Link,
  FileUpload,
  Modal,
  Spinner,
  Checkbox,
  ColumnLayout,
  Select,
  Tabs,
  Input,
  TokenGroup,
  Table
} from "@amzn/awsui-components-react";
import * as XLSX from 'xlsx';
import './styles.scss'
import { TextFilter } from "ag-grid-community";
const TANCConfigurationManager = (props) => {
  var [rows, setRows] = useState(props.getValues() || []);
  var [sampleFile, setSampleFile] = useState([]);
  var [errorMessage, setErrorMessage] = useState('');
  const [generatingSchemaLoader, setGeneratingSchemaLoader] = useState(false);
  const [existingSchema, setExistingSchema] = useState({});
  const defScaleValue = "36"
  const defPrecisionValue = "8"
  const defLengthValue = "2000"

  const datatypes = [
    { label: "INTEGER", value: "INTEGER" },
    { label: "DECIMAL", value: "DECIMAL" },
    { label: "CURRENCY", value: "CURRENCY" },
    { label: "BOOLEAN", value: "BOOLEAN" },
    { label: "VARCHAR", value: "VARCHAR" },
    { label: "DATE", value: "DATE" },
    // { label: "TIME", value: "TIME" },
    // { label: "TIMETZ", value: "TIMETZ" }
  ]

  const tanc_edit_type = [
    { label: "SELECT", value: "SELECT" },
    { label: "MULTI_SELECT", value: "MULTI_SELECT" },
    { label: "INPUT", value: "INPUT" }
  ]

  useEffect(() => {
    loadRows()
    return () => {
    };
  }, []);

  useEffect(() => {
    loadRows()
  }, [props?.reloadNotifiers])

  useEffect(() => {
    if (isInValid()) {
      let msg = ''
      if (props?.errorMessage) {
        msg = props?.errorMessage
      }
      setErrorMessage(msg)
    } else {
      setErrorMessage('')
      props.updateValue(getMergedInputValues())
    }
  }, [rows])

  useEffect(() => {
    if (sampleFile.length > 0) {
      suggestSchema()
    }
  }, [sampleFile])


  const suggestSchema = async () => {
    setGeneratingSchemaLoader(true)
    let file = sampleFile[0]
    let data = await file.arrayBuffer();
    const wb = XLSX.readFile(data, { sheetRows: 1 })
    const workbook = XLSX.read(data)
    const worksheet = workbook.Sheets[workbook.SheetNames[0]]
    var readOptions = { type: 'binary', raw: false, defval: null, cellNF: false, cellDates: true, cellText: false }
    const jsonData = XLSX.utils.sheet_to_json(worksheet, readOptions)
    const headerInfo = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "", raw: false, cellDates: true })

    const colNames = headerInfo[0]
    if (colNames.length > 1600) {
      setErrorMessage("Max columns allowed is 1600. The file exceeds the allowed column length")
    }

    // create schema
    let newRows = []
    colNames.forEach((col, index) => {
      let normalisedCol = getNormalisedColumnName(col)
      if (!existingSchema.includes(normalisedCol)) {
        let newRow = {}
          newRow[props.dataTypeKey] = getDataTypeForColumn(index, headerInfo)
          newRow[props.columnNameKey] = normalisedCol
          newRow[props.radioKey] = props.radioKeyDefault
          newRow[props.delsertKey] = props.delsertRadioKeyDefault
          newRow[props.scaleKey] = defScaleValue
          newRow[props.precisionKey] = defPrecisionValue
          newRow[props.lengthKey] = defLengthValue
          newRow[props.lastUpdatedTimeKey] = null
          newRow['field_tokens'] = []

        newRows.push(newRow)
      }
    })
    addBulkRows(newRows)
    setGeneratingSchemaLoader(false)
  }

  const getDataTypeForColumn = (index, headerInfo, defVal = 'VARCHAR') => {
    let annotation = {}
    let iter_length = headerInfo.length % 100;
    for (let i = 1; i < iter_length; i++) {
      let row = headerInfo[i]
      let boolArray = ["true", "false", "t", "f", "yes", "no"]
      if (row[index] == null
        || row[index] == undefined
        || row[index].toString().length <= 0) {
        continue
      }
      if (boolArray.indexOf(row[index].toString().toLowerCase()) >= 0) {
        increaseCount('BOOLEAN', 1, annotation)
      } else if (!isNaN(Number(row[index]))) {
        if (Number(row[index]) % 1 == 0 && Number(row[index]) < 2147483647) {
          // priority to decimal
          increaseCount('INTEGER', 1, annotation)
        } else {
          increaseCount('DECIMAL', 999, annotation)
        }
      } else if (!isNaN(new Date(row[index]))) {
        let dateSplit = row[index].split('T')
        // priority to TIMESTAMP
        if (dateSplit.length > 1 && dateSplit[1] != '') {
          increaseCount('TIMESTAMP', 1, annotation)
        } else {
          increaseCount('DATE', 1, annotation)
        }
      } else {
        increaseCount('VARCHAR', 1, annotation)
      }
    }
    let max = { value: 0, key: defVal }
    Object.keys(annotation).forEach((key) => {
      if (annotation[key] > max['value']) {
        max['value'] = annotation[key]
        max['key'] = key
      }
    })

    return max['key']

  }

  const increaseCount = (key, incVal, annotation) => {
    if (!annotation.hasOwnProperty(key)) {
      annotation[key] = 0
    }
    annotation[key] = annotation[key] + incVal
  }

  const getNormalisedColumnName = (colName) => {
    colName = colName.toLowerCase()
    colName = colName.trim()
    let defChar = ''
    colName = colName.replaceAll(/[&\/\\#,+()$~%.'":*?<>{}!@=|-]/g, defChar).replaceAll('^', defChar).replaceAll('[', defChar).replaceAll(']', defChar).replaceAll(';', defChar).replaceAll('`', defChar);
    colName = colName.substring(0, 127)
    colName = colName.replace(/ +/g, ' ');
    colName = colName.trim()
    colName = colName.replaceAll(' ', '_')
    return colName
  }

  const getMergedInputValues = () => {
    var filtered = rows?.filter(function (row) {
      return row != null;
    });
    for (let i = 0; i < filtered.length; i++) {
      if (filtered[i][props.dataTypeKey] == 'DECIMAL') {
        filtered[i][props.lengthKey] = null
        if (!filtered[i].hasOwnProperty(props.scaleKey) || filtered[i][props.scaleKey] == null) {
          filtered[i][props.scaleKey] = defScaleValue
        }
        if (!filtered[i].hasOwnProperty(props.precisionKey) || filtered[i][props.precisionKey] == null) {
          filtered[i][props.precisionKey] = defPrecisionValue
        }
      } else if (filtered[i][props.dataTypeKey] == 'VARCHAR') {
        filtered[i][props.scaleKey] = null
        filtered[i][props.precisionKey] = null
        if (!filtered[i].hasOwnProperty(props.lengthKey) || filtered[i][props.lengthKey] == null) {
          filtered[i][props.lengthKey] = defLengthValue
        }
      } else {
        filtered[i][props.lengthKey] = null
        filtered[i][props.scaleKey] = null
        filtered[i][props.precisionKey] = null
      }
    }
    return filtered
  }

  const isInValid = () => {
    return props.validator && !props.validator(getMergedInputValues())
  }

  const onEdit = (value, index, key) => {
    rows[index][key] = value
    rows[index][props.lastUpdatedTimeKey] = null
    setRows([...rows])
  }

  const getInputItemForTable = (value, index) => {

    let items = []
    Array.from(rows).map((value, index) => {
      items.push({
        column_name: <Input
          onChange={({ detail }) => {
            let val = detail.value
            if (props?.postProcess) {
              val = props.postProcess(detail.value)
            }
            onEdit(val, index, props.columnNameKey)
          }}
          placeholder={props.placeholder}
          value={value.hasOwnProperty(props.columnNameKey) ? value[props.columnNameKey] : ''}
        />,
        edit_type: <Select
          expandToViewport
          selectedOption={value[props.editTypeKey] ? { value: value[props.editTypeKey] } : null}
          onChange={({ detail }) =>
            onEdit(detail.selectedOption.value, index, props.editTypeKey)
          }
          options={tanc_edit_type}
          placeholder={props?.selectHint ? props.selectHint : "Choose options"}
        />,
        data_type: <Select
          expandToViewport
          selectedOption={value[props.dataTypeKey] ? { value: value[props.dataTypeKey] } : null}
          onChange={({ detail }) =>
            onEdit(detail.selectedOption.value, index, props.dataTypeKey)
          }
          options={datatypes}
          placeholder={props?.selectHint ? props.selectHint : "Choose options"}
        />,
        dropdowns: <>{
          value?.[props.editTypeKey] === 'SELECT' || value?.[props.editTypeKey] === 'MULTI_SELECT' ?
            <SpaceBetween direction="vertical">
              <div className="param_input">
                <Input
                  onChange={({ detail }) => {
                    let val = detail.value
                    onEdit({ label: val.trim(), dismissLabel: val.trim() }, index, 'typed_value')

                  }}
                  onKeyDown={({ detail }) => {
                    if (detail.key == 'Enter') {
                      if (value['typed_value'] == undefined || value['typed_value']?.label == undefined || value['typed_value']?.label == '') {

                      } else {
                        if (!value.hasOwnProperty('field_tokens')) {
                          value['field_tokens'] = []
                        }
                        value['field_tokens'].push(value['typed_value'])
                        // resetting the typed value for new values. Existing value is already added to token list
                        onEdit(undefined, index, 'typed_value')
                      }
                    }
                  }}
                  placeholder="values"
                  value={value?.typed_value?.label}
                  disabled={value?.field_type == 'input' ? true : (value.limit && value['field_tokens']?.length >= value.limit ? true : false)}
                />
                {
                  value?.typed_value?.label ? <span className="hintMessage">Press Enter for the values to be considered</span> : ''
                }
              </div>
              <TokenGroup
                onDismiss={({ detail: { itemIndex } }) => {
                  let arr = value?.field_tokens
                  arr.splice(itemIndex, 1)
                  onEdit(arr, index, 'field_tokens')
                }}
                items={value?.field_tokens}
              />
            </SpaceBetween> : <></>
        }</>,
        delete: <Button iconName="close" variant="icon" disabled={props.associationType == 'FRISCO'} onClick={() => {
          deleteRow(index)
        }} />
      })
    })
    return items
  }

  const getInputItem = (value, index) => {
    return <div className='rows' key={index}>
      <Container>
        <SpaceBetween direction="horizontal" size="xs" key={index}>
          <SpaceBetween direction="vertical">
            <Box variant="h4">Column name</Box>
            <Input
              onChange={({ detail }) => {
                let val = detail.value
                if (props?.postProcess) {
                  val = props.postProcess(detail.value)
                }
                onEdit(val, index, props.columnNameKey)
              }}
              placeholder={props.placeholder}
              value={value.hasOwnProperty(props.columnNameKey) ? value[props.columnNameKey] : ''}
            />
          </SpaceBetween>
          <SpaceBetween direction="vertical">
            <Box variant="h4">Edit type</Box>
            <Select
              selectedOption={value[props.editTypeKey] ? { value: value[props.editTypeKey] } : null}
              onChange={({ detail }) =>
                onEdit(detail.selectedOption.value, index, props.editTypeKey)
              }
              options={tanc_edit_type}
              placeholder={props?.selectHint ? props.selectHint : "Choose options"}
            />
          </SpaceBetween>

          <SpaceBetween direction="vertical">
            <Box variant="h4">Data type</Box>
            <Select
              selectedOption={value[props.dataTypeKey] ? { value: value[props.dataTypeKey] } : null}
              onChange={({ detail }) =>
                onEdit(detail.selectedOption.value, index, props.dataTypeKey)
              }
              options={datatypes}
              placeholder={props?.selectHint ? props.selectHint : "Choose options"}
            />
          </SpaceBetween>
          {
            value?.[props.editTypeKey] === 'SELECT' || value?.[props.editTypeKey] === 'MULTI_SELECT' ?
              <SpaceBetween direction="vertical">
                <div className="param_input">
                  <Box variant="h4">Drop down values</Box>
                  <Input
                    onChange={({ detail }) => {
                      let val = detail.value
                      onEdit({ label: val.trim(), dismissLabel: val.trim() }, index, 'typed_value')

                    }}
                    onKeyDown={({ detail }) => {
                      if (detail.key == 'Enter') {
                        if (value['typed_value'] == undefined || value['typed_value']?.label == undefined || value['typed_value']?.label == '') {

                        } else {
                          if (!value.hasOwnProperty('field_tokens')) {
                            value['field_tokens'] = []
                          }
                          value['field_tokens'].push(value['typed_value'])
                          // resetting the typed value for new values. Existing value is already added to token list
                          onEdit(undefined, index, 'typed_value')
                        }
                      }
                    }}
                    placeholder="values"
                    value={value?.typed_value?.label}
                    disabled={value?.field_type == 'input' ? true : (value.limit && value['field_tokens']?.length >= value.limit ? true : false)}
                  />
                  {
                    value?.typed_value?.label ? <span className="hintMessage">Press Enter for the values to be considered</span> : ''
                  }
                </div>
                <TokenGroup
                  onDismiss={({ detail: { itemIndex } }) => {
                    let arr = value?.field_tokens
                    arr.splice(itemIndex, 1)
                    onEdit(arr, index, 'field_tokens')
                  }}
                  items={value?.field_tokens}
                />
              </SpaceBetween> : <></>
          }



          <div className="row">
            <Button iconName="close" variant="icon" disabled={props.associationType == 'FRISCO'} onClick={() => {
              deleteRow(index)
            }} />

          </div>
        </SpaceBetween>
      </Container>
    </div>
  }

  const deleteRow = (index) => {
    rows.splice(index, 1)
    setRows([...rows])
  }

  const saveConfiguration = () => {
    props.notify({ 'ACTION': 'SAVE' })
  }

  const addNewRow = () => {
    addRow()
  }

  const addBulkRows = (newRows) => {
    setRows(newRows)
  }

  const addRow = (colName = '', datatype = null) => {
    var newRow = {}
    newRow[props.dataTypeKey] = datatype
    newRow[props.columnNameKey] = colName
    newRow[props.radioKey] = props.radioKeyDefault
    newRow[props.delsertKey] = props.delsertRadioKeyDefault
    newRow[props.scaleKey] = defScaleValue
    newRow[props.precisionKey] = defPrecisionValue
    newRow[props.lengthKey] = defLengthValue
    newRow[props.lastUpdatedTimeKey] = null
    newRow['field_tokens'] = []
    setRows([...rows, newRow])
  }

  const getActionButtons = () => {
    return <SpaceBetween direction="vertical" size="s">
      <SpaceBetween direction="horizontal" size="s">
        {
          props?.loadingMessage ? <SpaceBetween direction="horizontal" size="m">
            <Spinner></Spinner>
            <Box color={props.loadingMessage?.type == 'success' ? 'text-status-inactive' : 'text-status-error'}>{props.loadingMessage?.message}</Box>
          </SpaceBetween> : <></>
        }
        <Button onClick={addNewRow} disabled={props.associationType == 'FRISCO'}>Add column</Button>
        <Button variant="primary" onClick={saveConfiguration} disabled={props.tancId == null}>Save</Button>
      </SpaceBetween>
    </SpaceBetween>
  }

  const loadRows = () => {
    let values = props.getValues()
    if (values == null) {
      return
    }
    setRows(JSON.parse(JSON.stringify(values)))
    let existingSchema = values?.map(item => item[props.columnNameKey]);
    setExistingSchema(existingSchema)
  }

  return (
    <SpaceBetween size="m">
      {
        props?.loadingMessage ? <SpaceBetween direction="horizontal" size="m">
          <Spinner></Spinner>
          <Box color={props.loadingMessage?.type == 'success' ? 'text-status-inactive' : 'text-status-error'}>{props.loadingMessage?.message}</Box>
        </SpaceBetween> : <></>
      }
      {props.info && props.info != ' ' && props.info != '' ? <><span className="info">{props.info}</span> <br></br> </> : ''}
      {errorMessage && errorMessage != '' ? <><span className="error"> {errorMessage} </span><br></br></> : ''}

      <Table
        columnDefinitions={[
          {
            id: "column_name",
            header: "Columns",
            cell: item => item.column_name,
            sortingField: "name",
            isRowHeader: true
          },
          {
            id: "data_type",
            header: "Data type",
            cell: item => item.data_type
          },
          {
            id: "edit_type",
            header: "Edit type",
            cell: item => item.edit_type,
            sortingField: "alt"
          },
          {
            id: "dropdowns",
            header: "Dropdown values",
            cell: item => item.dropdowns
          },
          {
            id: "delete",
            header: "Actions",
            cell: item => item.delete,
            minWidth: 170
          }
        ]}
        columnDisplay={[
          { id: "column_name", visible: true },
          { id: "data_type", visible: true },
          { id: "edit_type", visible: true },
          { id: "dropdowns", visible: true },
          { id: "delete", visible: true }
        ]}
        enableKeyboardNavigation
        items={getInputItemForTable()}
        loadingText="Loading resources"
        empty={
          <Box
            margin={{ vertical: "xs" }}
            textAlign="center"
            color="inherit"
          >
            <SpaceBetween size="m">
              <b>No columns</b>
              <Button onClick={addNewRow} disabled={props.associationType == 'FRISCO'}>Add column</Button>
            </SpaceBetween>
          </Box>
        }
      />

      {/* <ColumnLayout columns={2}>
        {rows ? (Array.from(rows).map((value, index) => {
          return getInputItem(value, index);
        })) : ''}
      </ColumnLayout> */}

      <ColumnLayout columns={2}>
      <Box>
        {
        props.associationType != 'FRISCO'&&
          <div>
            <SpaceBetween size="m">
              <Box variant="awsui-key-label">Or upload a sample file to generate the schema</Box>
              <FileUpload
                onChange={({ detail }) => { setSampleFile(detail.value) }}
                value={sampleFile}
                i18nStrings={{
                  uploadButtonText: e =>
                    e ? "Choose files" : "Choose file",
                  dropzoneText: e =>
                    e
                      ? "Drop files to generate"
                      : "Drop file to generate",
                  removeFileAriaLabel: e =>
                    `Remove file ${e + 1}`,
                  limitShowFewer: "Show fewer files",
                  limitShowMore: "Show more files",
                  errorIconAriaLabel: "Error"
                }}
                showFileLastModified
                showFileSize
                showFileThumbnail
                tokenLimit={1}
                accept={'.csv'}
                constraintText="upload a sample csv file"
              />
              {
                generatingSchemaLoader ? <SpaceBetween size="l"><Box></Box><Box textAlign="center"><Spinner> </Spinner> generating schema... </Box></SpaceBetween> : <></>
              }
            </SpaceBetween>
          </div> 
      }
      </Box>
      <Box float="right">
        {
          getActionButtons()
        }
      </Box>
      </ColumnLayout>
      
    </SpaceBetween>
  )
}

export default TANCConfigurationManager;